import React from 'react';
import { ButtonWithText } from '../ButtonWithText';
import { useCSVReader } from 'react-papaparse';
import { CSVEleveResultsTypes } from 'types/user/eleve.def';
import { toast } from 'react-hot-toast';

interface UploadCSVButtonProps {
  onChange: (results: CSVEleveResultsTypes) => Promise<void>;
  text: string;
}

export const UploadCSVButton = ({ onChange, text }: UploadCSVButtonProps) => {
  const { CSVReader } = useCSVReader();

  return (
    <CSVReader
      onUploadAccepted={(results: CSVEleveResultsTypes) => {
        results.data.length >= 1
          ? onChange(results)
          : toast.error(`Aucun élève detecté dans le CSV 🗿`);
      }}
      config={{
        header: true
      }}
    >
      {({ getRootProps }) => (
        <ButtonWithText
          variant="primaryBlue"
          content={text}
          iconColor={'#FFF'}
          icon={'Upload'}
          {...getRootProps()}
        />
      )}
    </CSVReader>
  );
};
